var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16669 15.8332H5.21794L13.7484 7.30275L12.6971 6.2515L4.16669 14.7819V15.8332ZM2.91669 17.0832V14.2628L13.9088 3.27546C14.0347 3.16102 14.1738 3.07262 14.3261 3.01025C14.4784 2.94775 14.6381 2.9165 14.8052 2.9165C14.9723 2.9165 15.1341 2.94616 15.2906 3.00546C15.4473 3.06477 15.586 3.15907 15.7067 3.28838L16.7244 4.3188C16.8537 4.43949 16.9459 4.57838 17.0009 4.73546C17.0559 4.89255 17.0834 5.04963 17.0834 5.20671C17.0834 5.37435 17.0547 5.53428 16.9975 5.6865C16.9403 5.83887 16.8493 5.97803 16.7244 6.104L5.7371 17.0832H2.91669ZM13.2136 6.7863L12.6971 6.2515L13.7484 7.30275L13.2136 6.7863Z",
    fill: "#6929E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlue);
export default __webpack_public_path__ + "static/media/edit_blue.53899c36dafa51f2b965354a72f88692.svg";
export { ForwardRef as ReactComponent };